import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtFooterCustom]',
})
export class PaginationTableFooterCustomDirective {
	constructor(public template: TemplateRef<any>) {}
}
